export const SUN_FOCUS_ID = "__solar_sun__"
export const HUMANOID_GLB_URL = "/humanoid_from_blend.glb"
